import React from 'react';
import { Box, Columns } from 'modules/af_cm_ui_kit';
import fields, { FIELDS, INPUTS } from 'modules/cm/fields/types';
import { SectionProps } from './types';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import usePepperError from 'modules/cm/pages/CaseDetailsPage/hooks/useFieldError';
import UpdatableField from 'modules/cm/fields/UpdatableField';
import CaseStatusChangeField from 'modules/cm/fields/CaseStatusChangeField';

const UnderwritingSection: React.FC<SectionProps> = ({
  modulePrefix,
  resources,
  isStatusCompleted,
  caseStatusChange,
}) => {
  const { getErrors } = usePepperError('loanDetails');

  return (
    <Box title="Underwriting">
      <UpdatableField
        modulePrefix={modulePrefix}
        fieldType={INPUTS.SELECT}
        field={fields[FIELDS.OWNER]}
        options={resources.underwriters}
        getErrors={getErrors}
        withDefaultOption={true}
      />

      <CaseStatusChangeField
        modulePrefix={modulePrefix}
        field={fields[FIELDS.STATUS]}
        caseStatuses={resources.caseStatuses}
        onChange={caseStatusChange}
        withDefaultOption={true}
        searchable={false}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        getErrors={getErrors}
        fieldType={INPUTS.CHECKBOX}
        variant="inline"
        field={fields[FIELDS.IS_ON_HOLD_STATUS]}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        getErrors={getErrors}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.IS_APPLICATION_APPROVED_AUTHORITY_LEVELS]}
        variant="inline"
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        getErrors={getErrors}
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.IS_CALL_CARRIED_ALL_APPLICANTS]}
        variant="inline"
      />
      <UpdatableField
        fieldType={INPUTS.CHECKBOX}
        field={fields[FIELDS.IS_PEPPER_UPLOAD_APPROVED]}
        variant="inline"
        disabled={isStatusCompleted === false}
        getErrors={getErrors}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        getErrors={getErrors}
        fieldType={INPUTS.SELECT}
        field={fields[FIELDS.DELEGATED_AUTHORITY_LEVEL]}
        options={resources.authorityLevels}
        required
      />

      <Columns spacing={4}>
        <UpdatableField
          modulePrefix={modulePrefix}
          getErrors={getErrors}
          fieldType={INPUTS.SELECT}
          field={fields[FIELDS.INITIAL_ASSESSMENT_BY]}
          options={resources.underwriters}
          required
        />
        <UpdatableField
          modulePrefix={modulePrefix}
          getErrors={getErrors}
          fieldType={INPUTS.TEXT}
          variant={VARIANTS_TYPES.DATE}
          field={fields[FIELDS.INITIAL_ASSESSMENT_DATE]}
        />
      </Columns>
      <Columns spacing={4}>
        <UpdatableField
          modulePrefix={modulePrefix}
          getErrors={getErrors}
          fieldType={INPUTS.SELECT}
          field={fields[FIELDS.INITIAL_ASSESSMENT_APPROVED_BY]}
          options={resources.authorityLevels}
          required
        />
        <UpdatableField
          modulePrefix={modulePrefix}
          getErrors={getErrors}
          fieldType={INPUTS.TEXT}
          variant={VARIANTS_TYPES.DATE}
          field={fields[FIELDS.INITIAL_ASSESSMENT_APPROVED_DATE]}
        />
      </Columns>

      <UpdatableField
        modulePrefix={modulePrefix}
        getErrors={getErrors}
        fieldType={INPUTS.TEXTAREA}
        field={fields[FIELDS.UW_RECOMMENDATION]}
      />
      <UpdatableField
        modulePrefix={modulePrefix}
        getErrors={getErrors}
        fieldType={INPUTS.TEXTAREA}
        field={fields[FIELDS.UW_SPECIAL_CONDITIONS]}
      />
    </Box>
  );
};

export default UnderwritingSection;
